import React, { useEffect, useState } from "react";
import Content from "../../../components/Contents/Content";
import { Link, useLocation } from "react-router-dom";
import ReusableModal from "../../../components/Models/ReusableModal";
import {
  GetSignalClient,
  GetServicedata,
  GetCloseSignalClient,
  PlaceOrderApi,
  GetUserData,
  ExitPlaceOrderData,
  GetNsePriceData
} from "../../../Services/UserService/User";

import { fDate, fDateTimeH } from "../../../../Utils/Date_formate";
import { image_baseurl } from "../../../../Utils/config";

import Loader from "../../../../Utils/Loader";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import { Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";




function Trade() {


  const token = localStorage.getItem("token");
  const userid = localStorage.getItem("id");

  const location = useLocation();
  const signalType = location.state?.type;





  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(true)

  const [model, setModel] = useState(false);
  const [calltypedata, setCalltypedata] = useState("");
  const [viewModel, setViewModel] = useState(false);
  const [exitModel, setExitModel] = useState(false);
  const [service, setService] = useState([]);

  const [tradeData, setTradeData] = useState({ live: [], close: [] });
  const [showModal, setShowModal] = useState(false);
  const [description, setDescription] = useState("");
  const [avoidDescription, setAvoidDescription] = useState("");

  const [brokerstatus, setBrokerstatus] = useState([])
  const [targetEnabled, setTargetEnabled] = useState(1);
  const [checkdata, setCheckdata] = useState([])
  const [searchInput, setSearchInput] = useState("");
  const [message, setMessage] = useState([])

  const [tradingstatus, setTradingStatus] = useState([])





  const [orderdata, setOrderdata] = useState({
    id: "",
    signalid: "",
    quantity: "",
    price: "",
    tsprice: "",
    tsstatus: "",
    slprice: "",
    exitquantity: "",
    lotsize: ""
  })






  const [exitorderdata, setExitOrderdata] = useState({
    id: "",
    signalid: "",
    quantity: "",
    price: "",
    entrytype: ""
  })




  const UpdateExitdata = (item) => {
    setExitModel(true)
    setExitOrderdata({
      ...item,
      price: item.price,
      quantity: item.order_quantity,
    });
  };



  const UpdateData = (item) => {
    setModel(true);
    setOrderdata({
      ...item,
      price: item.price,
      tsprice: Math.max(item.tag1 || 0, item.tag2 || 0, item.tag3 || 0),
      slprice: item.stoploss,
      quantity: item.order_quantity == 0 ? "" : item.order_quantity,
      // exitquantity: item.order_quantity,
      lotsize: item.lotsize
    });
  };




  const [selectedService, setSelectedService] = useState(
    "66d2c3bebf7e6dc53ed07626"
  );


  const [selectedTab, setSelectedTab] = useState("live");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);





  useEffect(() => {
    fetchServiceData();
    fetchuserDetail()
    getnsedata()
  }, [selectedService]);

  useEffect(() => {
    if (signalType === "closetrade" || location?.state === "closetrade") {
      setSelectedTab("close")
    }
  }, [signalType])



  useEffect(() => {
    setPage(1);
  }, [selectedTab]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedTab === "live") {
          await fetchTradeData();
        } else if (selectedTab === "close") {
          await fetchCloseData();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [page, selectedTab, searchInput, selectedService]);



  const fetchServiceData = async () => {
    try {
      const response = await GetServicedata(token);
      if (response.status)
        setService(response.data);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };




  const getnsedata = async () => {
    try {
      const response = await GetNsePriceData(token);
      const checkdata = response?.data?.data?.map((item) => {
        return item
      })
      setCheckdata(checkdata)


    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };





  const fetchuserDetail = async () => {
    try {
      const response = await GetUserData(userid, token);
      if (response.status)
        setBrokerstatus(response?.data?.brokerid);
      setTradingStatus(response?.data?.tradingstatus);

    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };



  const PlanceOrderdata = async () => {
    try {
      const data = {
        id: userid,
        signalid: calltypedata?._id,
        quantity: orderdata.segment === "C" ? orderdata?.quantity : orderdata?.quantity * orderdata?.lotsize,
        price: orderdata?.price,
        tsprice: orderdata?.tsprice,
        tsstatus: targetEnabled,
        slprice: orderdata?.slprice,
        exitquantity: orderdata?.quantity,
      };

      const response = await PlaceOrderApi(data, token, brokerstatus);

      if (response.status) {
        showCustomAlert("Success", response.message || "Order Placed Successfully!")
        setOrderdata("")
        setModel(false)
      } else {
        showCustomAlert("error", response.message || "Failed to place the order. Please try again.")
      }
    } catch (error) {
      showCustomAlert("error", "An error occurred while placing the order. Please check your network or try again later.")

    }
  };



  const ExitPlaceOrder = async () => {
    try {
      const data = {
        id: userid,
        signalid: calltypedata?._id,
        quantity: exitorderdata?.quantity,
        price: exitorderdata?.price,

      };
      const response = await ExitPlaceOrderData(data, token, brokerstatus);
      if (response.status) {
        showCustomAlert("Success", response.message || "Order Exit Successfully!")
        setExitModel(false)
      } else {
        showCustomAlert("error", response.message || "Order Failed")
      }
    } catch (error) {
      showCustomAlert("error", "An error occurred while placing the order. Please check your network or try again later.")
    }
  };





  const fetchTradeData = async () => {
    try {
      const data = {
        page: page,
        service_id: selectedService,
        client_id: userid,
        search: searchInput,
      };
      const response = await GetSignalClient(data, token);
      if (response.status) {
        setMessage(response)
        setTradeData((prev) => ({ ...prev, live: response.data }));
        setTotalPages(response.pagination?.totalPages);
      }
    } catch (error) {
      console.error("Error fetching trade data:", error);
    }
    setIsLoading(false)
  };




  const fetchCloseData = async () => {
    try {
      const data = {
        page: page,
        service_id: selectedService,
        client_id: userid,
        search: searchInput,
      };
      const response = await GetCloseSignalClient(data, token);


      if (response.status) {
        setTradeData((prev) => ({ ...prev, close: response.data }));
        setTotalPages(response.pagination?.totalPages);
      }
    } catch (error) {
      console.error("Error fetching close trade data:", error);
    }
    setIsLoading(false)
  };




  const handleDownload = (item) => {
    if (item.report == null) {
      showCustomAlert("error", "No Data Available To See")
      return
    } else {
      const url = `${image_baseurl}uploads/report/${item.report}`;
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };



  // const calculatePnL = (item) => {
  //   if (!item || !item.price || !item.calltype) return "N/A";

  //   const entryPrice = parseFloat(item.price);
  //   const targetPrice = item.closeprice ? parseFloat(item.closeprice) : parseFloat(item.targetprice1);
  //   const callType = item.calltype.toUpperCase();

  //   if (isNaN(entryPrice) || isNaN(targetPrice)) return "N/A";

  //   let profitLossPercentage = 0;

  //   if (callType === "BUY") {
  //     profitLossPercentage = ((targetPrice - entryPrice) / entryPrice) * 100;
  //   } else if (callType === "SELL") {
  //     profitLossPercentage = ((entryPrice - targetPrice) / entryPrice) * 100;
  //   } else {
  //     return "Invalid Call Type";
  //   }

  //   return profitLossPercentage.toFixed(2) + "%";
  // };








  // const PotentialLeftButton = (item) => {
  //   if (!item || !checkdata) return null;

  //   const matchedStock = checkdata?.find(
  //     stock => stock?.SYMBOL?.trim().toUpperCase() === item?.stock?.trim().toUpperCase()
  //   );

  //   const entryPrice = parseFloat(matchedStock?.price) || 0;

  //   const targetPrices = [
  //     parseFloat(item?.tag1) || 0,
  //     parseFloat(item?.tag2) || 0,
  //     parseFloat(item?.tag3) || 0
  //   ].filter(price => price > 0);

  //   if (targetPrices.length === 0 || entryPrice === 0) return <div>0</div>;

  //   let potentialLeftPrice = 0;
  //   let potentialPercentage = 0;

  //   if (item?.segment === "C") {
  //     if (item?.calltype === "BUY") {
  //       const highestTarget = Math.max(...targetPrices);
  //       potentialLeftPrice = highestTarget - entryPrice;
  //     } else if (item?.calltype === "SELL") {
  //       const lowestTarget = Math.min(...targetPrices);
  //       potentialLeftPrice = entryPrice - lowestTarget;
  //     }
  //     potentialPercentage = ((potentialLeftPrice / entryPrice) * 100).toFixed(2);
  //   } else if (item?.segment === "O" || item?.segment === "F") {
  //     const lotSize = parseFloat(item?.lotsize) || 1;
  //     const price = parseFloat(item?.price) || 0;
  //     const target = item?.calltype === "BUY"
  //       ? Math.max(...targetPrices)
  //       : Math.min(...targetPrices);

  //     const priceDiff = item?.calltype === "BUY" ? (target - price) : (price - target);
  //     potentialLeftPrice = priceDiff * lotSize;

  //     potentialPercentage = ((priceDiff / price) * 100).toFixed(2);
  //   }

  //   return <div>{potentialPercentage}</div>;
  // };



  const calculatePnL = (item) => {
    if (!item || !item.price || !item.calltype) return { percent: "N/A", total: "N/A" };

    const entryPrice = parseFloat(item.price);
    const lotSize = parseFloat(item.lotsize) || 1;
    const targetPrice = item.closeprice
      ? parseFloat(item.closeprice)
      : parseFloat(item.targetprice1);

    const callType = item.calltype.toUpperCase();

    if (isNaN(entryPrice) || isNaN(targetPrice)) return { percent: "N/A", total: "N/A" };

    let priceDiff = 0;

    if (callType === "BUY") {
      priceDiff = targetPrice - entryPrice;
    } else if (callType === "SELL") {
      priceDiff = entryPrice - targetPrice;
    } else {
      return { percent: "Invalid", total: "Invalid" };
    }

    // ✅ percent calculation
    const percent = ((priceDiff / entryPrice) * 100).toFixed(2);

    // ✅ total calculation (for O/F segment)
    const total = (priceDiff * lotSize).toFixed(2);

    return { percent, total };
  };




  // const PotentialLeftButton = (item) => {
  //   if (!item || !checkdata) return { percent: 0, total: 0 };

  //   const matchedStock = checkdata?.find(
  //     stock => stock?.SYMBOL?.trim().toUpperCase() === item?.stock?.trim().toUpperCase()
  //   );

  //   const entryPrice = parseFloat(matchedStock?.price) || 0;

  //   const targetPrices = [
  //     parseFloat(item?.tag1) || 0,
  //     parseFloat(item?.tag2) || 0,
  //     parseFloat(item?.tag3) || 0
  //   ].filter(p => p > 0);

  //   if (targetPrices.length === 0 || entryPrice === 0) return { percent: 0, total: 0 };

  //   let total = 0;
  //   let percent = 0;

  //   if (item.segment === "C") {
  //     const highestTarget = Math.max(...targetPrices);
  //     const lowestTarget = Math.min(...targetPrices);

  //     if (item.calltype === "BUY") {
  //       total = highestTarget - entryPrice;
  //     } else {
  //       total = entryPrice - lowestTarget;
  //     }

  //     percent = (total / entryPrice * 100).toFixed(2);
  //   } else {
  //     const lotSize = parseFloat(item.lotsize) || 1;
  //     const price = parseFloat(item.price) || 0;
  //     const target = item.calltype === "BUY" ? Math.max(...targetPrices) : Math.min(...targetPrices);

  //     const priceDiff = item.calltype === "BUY" ? (target - price) : (price - target);
  //     total = priceDiff * lotSize;
  //     percent = (priceDiff / price * 100).toFixed(2);
  //   }

  //   return { percent, total };
  // };



  // const PotentialLeftButton = (item) => {
  //   if (!item || !checkdata) return { percent: 0, total: 0 };

  //   const matchedStock = checkdata?.find(
  //     stock => stock?.SYMBOL?.trim().toUpperCase() === item?.stock?.trim().toUpperCase()
  //   );



  //   const entryPrice = parseFloat(matchedStock?.price) || parseFloat(item?.price) || 0;
  //   const itemPrice = parseFloat(item?.price) || 0;

  //   const targetPrices = [
  //     parseFloat(item?.tag1) || 0,
  //     parseFloat(item?.tag2) || 0,
  //     parseFloat(item?.tag3) || 0
  //   ].filter(p => p > 0);

  //   if (targetPrices.length === 0 || entryPrice === 0) return { percent: 0, total: 0 };

  //   let total = 0;
  //   let percent = 0;

  //   if (item.segment === "C") {
  //     const highestTarget = Math.max(...targetPrices);
  //     const lowestTarget = Math.min(...targetPrices);

  //     if (item.calltype === "BUY") {
  //       const effectivePrice = entryPrice > itemPrice ? entryPrice : itemPrice;
  //       total = highestTarget - effectivePrice;
  //       percent = entryPrice < highestTarget ? ((total / entryPrice) * 100).toFixed(2) : 0;
  //     } else {
  //       const effectivePrice = entryPrice < itemPrice ? entryPrice : itemPrice;
  //       total = effectivePrice - lowestTarget;
  //       percent = entryPrice > lowestTarget ? ((total / entryPrice) * 100).toFixed(2) : 0;
  //     }
  //   } else {
  //     const lotSize = parseFloat(item.lotsize) || 1;
  //     const price = parseFloat(item.price) || 0;
  //     const target = item.calltype === "BUY" ? Math.max(...targetPrices) : Math.min(...targetPrices);

  //     const priceDiff = item.calltype === "BUY" ? (target - price) : (price - target);
  //     total = priceDiff * lotSize;
  //     percent = price !== 0 ? ((priceDiff / price) * 100).toFixed(2) : 0;
  //   }

  //   return { percent: Number(percent), total: Number(total) };
  // };



  const PotentialLeftButton = (item) => {
    if (!item || !checkdata) return { percent: 0, total: 0 };

    const matchedStock = checkdata?.find(
      stock => stock?.SYMBOL?.trim().toUpperCase() === item?.stock?.trim().toUpperCase()
    );

    const entryPrice = parseFloat(matchedStock?.price) || parseFloat(item?.price) || 0;
    const itemPrice = parseFloat(item?.price) || 0;

    const targetPrices = [
      parseFloat(item?.tag1) || 0,
      parseFloat(item?.tag2) || 0,
      parseFloat(item?.tag3) || 0
    ].filter(p => p > 0);

    if (targetPrices.length === 0 || entryPrice === 0) return { percent: 0, total: 0 };

    let total = 0;
    let percent = 0;

    if (item.segment === "C") {
      const highestTarget = Math.max(...targetPrices);
      const lowestTarget = Math.min(...targetPrices);

      let effectivePrice = entryPrice; // default
      let target = 0;

      if (item.calltype === "BUY") {
        effectivePrice = entryPrice > itemPrice ? entryPrice : itemPrice;
        total = highestTarget - effectivePrice;
        target = highestTarget;
      } else { // SELL
        effectivePrice = entryPrice < itemPrice ? entryPrice : itemPrice;
        total = effectivePrice - lowestTarget;
        target = lowestTarget;
      }

      // Percent calculation same line for both BUY and SELL
      percent = entryPrice < target ? ((total / entryPrice) * 100).toFixed(2) : 0;

    } else {
      const lotSize = parseFloat(item.lotsize) || 1;
      const price = parseFloat(item.price) || 0;
      const target = item.calltype === "BUY" ? Math.max(...targetPrices) : Math.min(...targetPrices);

      const priceDiff = item.calltype === "BUY" ? (target - price) : (price - target);
      total = priceDiff * lotSize;
      percent = price !== 0 ? ((priceDiff / price) * 100).toFixed(2) : 0;
    }

    return { percent: Number(percent), total: Number(total) };
  };






  const formatTradeSymbol = (symbol) => {
    if (!symbol) return "Trade Symbol";
    return symbol.replace(/^([A-Z]+)(\d{2}[A-Z]{3}\d{2})([A-Z]+)$/, '$1 $2 $3');
  };


  const formatExpiryDate = (rawDate) => {
    if (!rawDate || rawDate.length !== 8) return rawDate;
    const day = rawDate.slice(0, 2);
    const month = rawDate.slice(2, 4);
    const year = rawDate.slice(4, 8);
    return `${day}-${month}-${year}`;
  };



  const renderTradeCard = (item) => (

    < div className="row" key={item._id} >
      <div className="col-md-12">
        <div className="trade-card shadow" style={{ backgroundColor: "#dcedf2" }}>
          <div className="row mb-3">
            <div className="col-lg-6">
              <h4 className="text-yellow"><b>{formatTradeSymbol(item?.tradesymbol)}</b></h4>
              <span className="date-btn">
                <i class="fa-solid fa-calendar me-3"></i>
                <b>{selectedTab === "live" ? fDateTimeH(item?.created_at) : fDateTimeH(item?.closedate)}</b>
              </span>
            </div>
            {/* {selectedTab === "live" && 
            <div className="col-lg-3">
              <button className="btn btn-light" style={{ borderRadius: "20px", padding: "0px 10px", fontSize: "15px" }}>
                Sugg. Qty : {item?.lot ? item.lot : " - "}
              </button>
            </div>}

            <div className={`${selectedTab === "live" ? "col-lg-3" : "offset-5 col-lg-2"} `}>
              <button className="btn btn-light" style={{ borderRadius: "20px", padding: "0px 10px", fontSize: "15px" }}>
                {item?.callduration}
              </button>
            </div> */}




            <div className="trade-header col-lg-3">

              <div className="mb-3">
                <span className="trade-type1">
                  {service?.find((srv) => srv?._id === item?.service)?.title}

                </span>
                <br />
                <span className="trade-type">
                  Hold Duration :{" "}
                  {
                    item?.callduration === "Intraday" ? "Intraday" :
                      item?.callduration === "Short Term" ? "(1 Month - 6 Months)" :
                        item?.callduration === "Medium Term" ? "(Above 3 Months)" :
                          item?.callduration === "Swing" ? "(1-30 days)" :
                            item?.callduration === "Long Term" ?
                              "(Above 1Year)" : item?.callduration === "Still Expiry Date" ? formatExpiryDate(item?.expirydate) : item?.callduration
                  }

                  <span style={{ color: "red", marginLeft: "4px" }}>
                    {item?.closeprice == 0 && <>
                      {"(Avoid)"}
                      <Eye
                        onClick={() => {
                          setShowModal(true);
                          setAvoidDescription(item?.close_description

                          );
                        }}
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                      />
                    </>}

                  </span>


                </span>
              </div>

            </div>
            {selectedTab === "live" ?
              <div className="col-lg-3 text-end">
                {(() => {
                  const potential = PotentialLeftButton(item);

                  return (
                    <button
                      className={`btn d-flex ${potential.total < 0 ? "btn-danger" : "btn-success"}`}
                      style={{ padding: "0px 10px", fontSize: "15px" }}
                    >
                      Potential Left :&nbsp;
                      {item.segment === "C"
                        ? `${potential.percent}%`
                        : `${potential.total.toLocaleString()} (${potential.percent})%`}
                    </button>
                  );
                })()}
              </div> :
              item?.closeprice <= 0 ? "" : <div className="col-lg-3 text-end">
                {(() => {
                  const pnl = calculatePnL(item);

                  return (
                    <button
                      className={`btn d-flex ${parseFloat(pnl.total) < 0 ? "btn-danger" : "btn-success"}`}
                      style={{ padding: "0px 10px", fontSize: "15px" }}
                    >
                      P&L : {item.segment === "C"
                        ? `${pnl.percent}%`
                        : `${Number(pnl.total).toFixed(2)}`}

                    </button>
                  );
                })()}
              </div>
            }
          </div>

          {/* <div className="row bg-white">

            <div className="col-md-2 d-flex align-items-center">
              <div className="trade-header">

                <div className="mb-3">
                  <span className="trade-type1">
                    {service?.find((srv) => srv?._id === item?.service)?.title}

                  </span>
                  <br />
                  <span className="trade-type">
                    Hold Duration :{" "}
                    {
                      item?.callduration === "Intraday" ? "Intraday" :
                        item?.callduration === "Short Term" ? "(1 Month - 6 Months)" :
                          item?.callduration === "Medium Term" ? "(Above 3 Months)" :
                            item?.callduration === "Swing" ? "(1-30 days)" :
                              item?.callduration === "Long Term" ?
                                "(Above 1Year)" : item?.callduration === "Still Expiry Date" ? formatExpiryDate(item?.expirydate) : item?.callduration
                    }

                    <span style={{ color: "red", marginLeft: "4px" }}>
                      {item?.closeprice == 0 && <>
                        {"(Avoid)"}
                        <Eye
                          onClick={() => {
                            setShowModal(true);
                            setAvoidDescription(item?.close_description

                            );
                          }}
                          style={{ cursor: "pointer", marginLeft: "5px" }}
                        />
                      </>}

                    </span>


                  </span>
                </div>

              </div>
                  {selectedTab === "live" ?
              <div className="col-lg-3 text-end">
                <button className="btn btn-success d-flex " >
                  Potential Left : {PotentialLeftButton(item)}%
                </button>
              </div> :
              item?.closeprice <= 0 ? "" : <div className="col-lg-3 text-end ">
                <button className={`btn btn-success ${parseFloat(calculatePnL(item)) >= 0 ? "btn-success" : "btn-danger"}`} style={{ padding: "0px 10px", fontSize: "15px" }}>
                  P&L : {calculatePnL(item)}
                </button>
              </div>
            }
          </div>

          {/* <div className="row bg-white">

            <div className="col-md-2 d-flex align-items-center">
              <div className="trade-header">

                <div className="mb-3">
                  <span className="trade-type1">
                    {service?.find((srv) => srv?._id === item?.service)?.title}
                  </span>
                  <br />
                  <span className="trade-type">
                    Hold Duration :{" "}
                    {
                      item?.callduration === "Intraday" ? "Intraday" :
                        item?.callduration === "Short Term" ? "(1 Month - 6 Months)" :
                          item?.callduration === "Medium Term" ? "(Above 3 Months)" :
                            item?.callduration === "Swing" ? "(1-30 days)" :
                              item?.callduration === "Long Term" ?
                                "(Above 1Year)" : item?.callduration === "Still Expiry Date" ? formatExpiryDate(item?.expirydate) : item?.callduration
                    }
                    <span style={{ color: "red", marginLeft: "4px" }}>
                      {item?.closeprice == 0 && <>
                        {"(Avoid)"}
                        <Eye
                          onClick={() => {
                            setShowModal(true);
                            setAvoidDescription(item?.close_description

                            );
                          }}
                          style={{ cursor: "pointer", marginLeft: "5px" }}
                        />
                      </>}
                    </span>
                  </span>
                </div>

              </div>
            </div>

            <div className="col-md-12 col-lg-7">
              <div className="trade-content">
                <div className="d-sm-flex justify-content-between tradehead mb-3">
                  <h4><b>{formatTradeSymbol(item?.tradesymbol)}</b></h4>
                  <h5>
                    {selectedTab !== "live" && (
                      <span>Entry Type: {item?.calltype} {item?.entrytype}</span>)}
                  
                  </h5>

                  {selectedTab === "live" && (
                    <span>
                      <b>Partially Closed</b>:{" "}
                      {item?.targethit3 && item?.targetprice3
                        ? item?.targetprice3
                        : item?.targethit2 && item?.targetprice2
                          ? item?.targetprice2
                          : item?.targethit1 && item?.targetprice1
                            ? item?.targetprice1
                            : "--"}
                    </span>)}
                </div>
                <div className="trade-details row justify-content-center">
                  {[
                    { label: "Entry price", value: `₹${item?.price}` },
                    ...(selectedTab === "close"
                      ? [{ label: "Exit Price", value: item?.closeprice || "--" }]
                      : []),
                    ...(selectedTab === "live" ? [{ label: "Entry Type", value: `${item?.calltype} ${item?.entrytype}` }] : []),
                    { label: "Stoploss", value: item?.stoploss || "--" },
                    { label: "Target1", value: item?.tag1 || "--" },
                    { label: "Target2", value: item?.tag2 || "--" },
                    { label: "Target3", value: item?.tag3 || "--" },

                  ]?.map((detail, idx) => (
                    <div
                      className={`col-md-${idx < 2 ? 4 : 4} d-flex justify-content-md-${idx < 2 ? "start" : "start"
                        }`}
                      key={idx}
                    >
                      <div>
                        <strong>{detail?.label}:</strong>
                        <p>{detail?.value}</p>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>

            <div className="col-md-12 col-lg-3 d-flex align-items-center">
              <div className="d-flex flex-column w-100">

                {selectedTab === "close" ? (
                  <>
                    {Number(item?.closeprice) <= 0 ? (
                      <button className="btn w-100 my-1 btn-danger">
                        Avoid
                      </button>
                    ) : (

                      <button
                        className="btn w-100 my-1"
                        style={{
                          backgroundColor:
                            item?.purchased === false || new Date(item?.created_at) > new Date()
                              ? "#ccc"
                              : "#0d6efd",
                          color: "black",
                          border: "1px solid black",
                        }}
                        disabled={
                          item?.purchased === false || new Date(item?.created_at) > new Date()
                        }
                        onClick={() => {
                          if (brokerstatus === 0) {
                            showCustomAlert("error", "Client Broker Not Login, Please Login With Broker.");
                            return;
                          }
                          UpdateExitdata(item);
                          setCalltypedata(item);
                        }}
                      >
                        {item?.purchased === false || new Date(item?.created_at) > new Date()
                          ? "Trade Closed"
                          : "EXIT"}
                      </button>
                    )}
                  </>
                ) : (

                  <button
                    className="btn w-100 my-1"
                    onClick={() => {
                      if (brokerstatus === 0) {
                        showCustomAlert("error", "Client Broker Not Login, Please Login With Broker.");
                        return;
                      }
                      setCalltypedata(item);
                      UpdateData(item);
                    }}
                    style={{
                      backgroundColor: item?.calltype === "BUY" ? "green" : "red",
                      color: "white",
                    }}
                  >
                    {`${item?.calltype === "BUY" ? "BUY" : "SELL"}${item?.purchased ? " (Add more)" : ""
                      }`}
                  </button>
                )}


                <button
                  className="btn btn-light w-100 my-1"
                  onClick={() => {
                    setViewModel(true);
                    setDescription(item?.description);

                  }}
                >
                  View Detail
                </button>
                <button
                  className="btn w-100 my-1"
                  style={{
                    backgroundColor: item?.report ? "green" : "#ccc",
                    color: item?.report ? "white" : "black",
                    border: "1px solid black",
                  }}
                  onClick={() => handleDownload(item)}
                  disabled={!item?.report}
                >
                  View Analysis
                </button>

                {item?.purchased && (
                  <>
                    <Link to="/user/broker-response-deatil" state={{ row: item }}>
                      <button className="btn btn-light w-100 my-1">
                        Broker Response
                      </button>
                    </Link>
                  </>
                )}

              </div>
            </div>
          </div>
          </div> */}
          <div className="row bg-white">


            <div className="col-md-12 col-lg-9">
              <div className="trade-content ">
                <div className="row mb-2">

                  {selectedTab === "live" &&
                    <div className="col-lg-4">
                      <button className="btn btn-light" style={{ borderRadius: "20px", padding: "0px 10px", fontSize: "15px" }}>
                        Sugg. Qty : {item?.lot ? item.lot : " - "}
                      </button>
                    </div>}

                  <div className={`${selectedTab === "live" ? "col-lg-4" : "col-lg-4"} `}>
                    <button className="btn btn-light" style={{ borderRadius: "20px", padding: "0px 10px", fontSize: "15px" }}>
                      {item?.callduration}
                    </button>
                  </div>


                  {/* 
            {selectedTab === "live" ?
              <div className="col-lg-3 text-end">
                <button className="btn btn-success d-flex " style={{ marginLeft: "40px", padding: "0px 10px", fontSize: "15px" }}>
                  Potential Left : {PotentialLeftButton(item)}%
                </button>
              </div> :
              item?.closeprice <= 0 ? "" :
              
              <div className="col-lg-2 text-end ">
                <button className={`btn btn-success ${parseFloat(calculatePnL(item)) >= 0 ? "btn-success" : "btn-danger"}`} style={{ padding: "0px 10px", fontSize: "15px" }}>
                  P&L : {calculatePnL(item)}
                </button>
              </div>
            } */}
                  <div className="  col-lg-4">

                    <h6>
                      {selectedTab !== "live" && (
                        <span><b>Entry Type:</b> {item?.calltype} {item?.entrytype}</span>)}
                      {/* {item.targethit3 === "1" ? item.targetprice3
                      : item.targethit2 === "1" ? item.targetprice2
                        : item.targethit1 === "1" ? item.targetprice1
                          : ""} */}
                    </h6>

                    {selectedTab === "live" && (item?.targethit3 || item?.targethit2 || item?.targethit2) && (
                      <span>
                        <b>Partially Closed</b>:{" "}
                        {item?.targethit3 && item?.targetprice3
                          ? item?.targetprice3
                          : item?.targethit2 && item?.targetprice2
                            ? item?.targetprice2
                            : item?.targethit1 && item?.targetprice1
                              ? item?.targetprice1
                              : "--"}
                      </span>)}
                  </div>
                </div>

                <div className="trade-details row justify-content-center">
                  {[
                    { label: "Entry price", value: `₹${item?.price}` },
                    ...(selectedTab === "close"
                      ? [{ label: "Exit Price", value: item?.closeprice || "--" }]
                      : []),
                    ...(selectedTab === "live" ? [{ label: "Entry Type", value: `${item?.calltype} ${item?.entrytype}` }] : []),
                    { label: "Stoploss", value: item?.stoploss || "--" },
                    { label: "Target 1", value: item?.tag1 || "--" },
                    { label: "Target 2", value: item?.tag2 || "--" },
                    { label: "Target 3", value: item?.tag3 || "--" },

                  ]?.map((detail, idx) => (
                    <div
                      className={`col-md-${idx < 2 ? 4 : 4} d-flex justify-content-md-${idx < 2 ? "start" : "start"
                        }`}
                      key={idx}
                    >
                      <div className="d-flex">
                        <strong> {detail?.label}:</strong>
                        <p className="">{detail?.value}</p>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>

            <div className="col-md-12 col-lg-3 ">

              <div className="d-flex flex-column w-100">

                {selectedTab === "close" ? (
                  <>
                    {Number(item?.closeprice) <= 0 ? (
                      <button className="btn w-100 my-1 btn-danger">
                        Avoid
                      </button>
                    ) : (

                      <button
                        className="btn w-100 my-1"
                        style={{
                          backgroundColor:
                            item?.purchased === false || new Date(item?.created_at) > new Date()
                              ? "#ccc"
                              : "#0d6efd",
                          color: "black",
                          border: "1px solid black",
                        }}
                        disabled={
                          item?.purchased === false || new Date(item?.created_at) > new Date()
                        }
                        onClick={() => {
                          if (tradingstatus == 0) {
                            showCustomAlert("error", "Client Broker Not Login, Please Login With Broker.");
                            return;
                          }
                          UpdateExitdata(item);
                          setCalltypedata(item);
                        }}
                      >
                        {item?.purchased === false || new Date(item?.created_at) > new Date()
                          ? "Trade Closed"
                          : "EXIT"}
                      </button>
                    )}
                  </>
                ) : (

                  <button
                    className="btn w-100 my-1"
                    onClick={() => {
                      if (tradingstatus == 0) {
                        showCustomAlert("error", "Client Broker Not Login, Please Login With Broker.");
                        return;
                      }
                      setCalltypedata(item);
                      UpdateData(item);
                    }}
                    style={{
                      backgroundColor: item?.calltype === "BUY" ? "green" : "red",
                      color: "white",
                    }}
                  >
                    {`${item?.calltype === "BUY" ? "BUY" : "SELL"}${item?.purchased ? " (Add more)" : ""
                      }`}
                  </button>
                )}


                <button
                  className="btn btn-light w-100 my-1"
                  onClick={() => {
                    setViewModel(true);
                    setDescription(item?.description);

                  }}
                >
                  View Detail
                </button>
                <button
                  className="btn w-100 my-1"
                  style={{
                    backgroundColor: item?.report ? "green" : "#ccc",
                    color: item?.report ? "white" : "black",
                    border: "1px solid black",
                  }}
                  onClick={() => handleDownload(item)}
                  disabled={!item?.report}
                >
                  View Analysis
                </button>



                {item?.purchased && (
                  <>
                    <Link to="/user/broker-response-deatil" state={{ row: item }}>
                      <button className="btn btn-light w-100 my-1">
                        Broker Response
                      </button>
                    </Link>
                  </>
                )}

              </div>
            </div>
          </div>


        </div>
      </div>
    </div >
  );



  // const handlePageChange = (direction) => {
  //   if (direction === "prev" && page > 1) {
  //     setPage(page - 1);
  //   } else if (direction === "next" && page < totalPages) {
  //     setPage(page + 1);
  //   }
  // };


  const handlePageChange = (directionOrPage) => {
    if (typeof directionOrPage === "string") {
      if (directionOrPage === "prev" && page > 1) {
        setPage(page - 1);
      } else if (directionOrPage === "next" && page < totalPages) {
        setPage(page + 1);
      }
    } else {
      setPage(directionOrPage);
    }
  };



  const handleSubscribe = () => {
    navigate("/user/service");
  };



  return (
    <Content Page_title="Trades" button_title="Add Trade" button_status={false}>
      <div className="page-content">
        <div className="row align-items-end g-3">
          <div className="col-lg-6">
            <label htmlFor="planSelect" className="form-label">
              Trades for you
            </label>
            <select
              id="planSelect"
              className="form-select"
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
            >
              {service?.map((item) => (
                <option key={item._id} value={item._id}>
                  {item?.title}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-6 ">
            <label htmlFor="searchInput" className="form-label fw-semibold">
              🔍 Search
            </label>
            <div className="input-group">
              <input
                type="text"
                id="searchInput"
                className="form-control rounded shadow-sm"
                placeholder="Type to search..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                aria-label="Search input"
              />
            </div>
          </div>
        </div>

        <ul
          className="nav nav-pills border-bottom my-3 justify-content-center"
          role="tablist"
        >
          {[
            { tab: "live", label: "Live Trade" },
            { tab: "close", label: "Close Trade" },
            // { tab: "live", icon: "bx-home", label: "Live Trade" },
            // { tab: "close", icon: "bx-user-pin", label: "Close Trade" },
          ]?.map(({ tab, icon, label }) => (
            <li className="nav-item" role="presentation" key={tab}>
              <a
                className={`nav-link ${selectedTab === tab ? "btn-primary active" : ""
                  }`}
                onClick={() => setSelectedTab(tab)}
                role="tab"
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex align-items-center">
                  <div className="tab-icon">
                    <i className={`bx ${icon} font-18 me-1`} />
                  </div>
                  <div
                    className={`tab-title ${selectedTab === tab ? "btn-primary" : ""
                      }`}
                  >
                    {label}
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>

        <div className="tab-content">
          {isLoading ? <Loader /> : message.message === "Signals retrieved successfully" ? tradeData[selectedTab]?.map(renderTradeCard) :

            <div className="text-center mt-4">
              <img src="/assets/images/nodata.png" alt="No Records Found" className="w-25" />
            </div>
          }
        </div>
        {message.message === "Signals retrieved successfully" &&
          <div className="pagination-controls d-flex justify-content-between align-items-center mt-4 p-3 rounded shadow-sm" style={{ backgroundColor: "#f8f9fa" }}>
            <button
              className="btn btn-light"
              onClick={() => handlePageChange("prev")}
              disabled={page === 1}
            >
              &laquo; Previous
            </button>


            <div className="d-flex gap-2">
              {Array.from({ length: totalPages }, (_, index) => {
                const pageNum = index + 1;
                return (
                  <button
                    key={pageNum}
                    className={`btn ${page === pageNum ? "btn-primary" : "btn-secondary"} btn-sm`}
                    onClick={() => handlePageChange(pageNum)}
                  >
                    {pageNum}
                  </button>
                );
              })}
            </div>

            <button
              className="btn btn-light"
              onClick={() => handlePageChange("next")}
              disabled={page === totalPages}
            >
              Next &raquo;
            </button>
          </div>}

      </div>





      <ReusableModal
        show={model}
        onClose={() => {
          setModel(false);
          setOrderdata("");
        }}
        title={<span>{calltypedata?.tradesymbol}</span>}
        body={
          <form className="row g-3">
            <div className="col-md-12">
              <label htmlFor="inputName" className="form-label">
                Price
              </label>
              <input
                type="number"
                className="form-control"
                id="inputName"
                placeholder="Price"
                value={orderdata?.price}
                onChange={(e) =>
                  setOrderdata({ ...orderdata, price: e.target.value })
                }
              />
            </div>

            {orderdata?.segment === "C" && (
              <div className="col-md-12">
                <label htmlFor="inputQuantity" className="form-label">
                  Quantity
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="inputQuantity"
                  placeholder="Quantity"
                  value={orderdata?.quantity}
                  onChange={(e) =>
                    setOrderdata({ ...orderdata, quantity: e.target.value })
                  }
                />
              </div>
            )}

            {orderdata?.segment !== "C" && (
              <>
                <div className="col-md-6">
                  <label htmlFor="inputLotsize" className="form-label">
                    Quantity (LotSize : {orderdata?.lotsize})
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="inputLotsize"
                    placeholder="Lot Size"
                    value={orderdata?.lotsize}
                    disabled
                  />
                </div>

                <div className="col-md-1 d-flex align-items-end justify-content-center">
                  <span style={{ fontSize: "1.5rem" }}>*</span>
                </div>

                <div className="col-md-5">
                  <label htmlFor="inputQuantity" className="form-label"></label>
                  <input
                    type="number"
                    className="form-control"
                    id="inputQuantity"
                    placeholder="Quantity"
                    onChange={(e) =>
                      setOrderdata({ ...orderdata, quantity: e.target.value })
                    }
                  />
                </div>
              </>
            )}

            {/* ✅ Target / Stoploss - Only one at a time */}
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="targetCheckbox"
                      checked={targetEnabled === 1}
                      onChange={(e) => {
                        setTargetEnabled(e.target.checked ? 1 : 0);
                      }}
                    />
                    <label className="form-check-label" htmlFor="targetCheckbox">
                      Target
                    </label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="stoplossCheckbox"
                      checked={targetEnabled === 2}
                      onChange={(e) => {
                        setTargetEnabled(e.target.checked ? 2 : 0);
                      }}
                    />
                    <label className="form-check-label" htmlFor="stoplossCheckbox">
                      Stoploss
                    </label>
                  </div>
                </div>
              </div>

              <input
                type="text"
                className="form-control mt-2"
                placeholder={
                  targetEnabled === 1
                    ? "Target Price"
                    : targetEnabled === 2
                      ? "Stoploss Price"
                      : "Select Target or Stoploss"
                }
                value={
                  targetEnabled === 1
                    ? orderdata.tsprice || ""
                    : targetEnabled === 2
                      ? orderdata.slprice || ""
                      : ""
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (targetEnabled === 1) {
                    setOrderdata({ ...orderdata, tsprice: value });
                  } else if (targetEnabled === 2) {
                    setOrderdata({ ...orderdata, slprice: value });
                  }
                }}
                disabled={targetEnabled === 0}
              />
            </div>

            <div className="col-md-12">
              <label htmlFor="inputQuantity" className="form-label">
                Exit Quantity
              </label>
              <input
                disabled
                type="number"
                className="form-control"
                id="inputQuantity"
                placeholder="Quantity"
                value={orderdata?.quantity || ""}
                onChange={(e) =>
                  setOrderdata({ ...orderdata, quantity: e.target.value })
                }
              />
            </div>
          </form>
        }
        footer={
          <>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                PlanceOrderdata();
              }}
            >
              {calltypedata.calltype === "BUY" ? "BUY" : "SELL"}
            </button>
            <button className="btn btn-light" onClick={() => setModel(false)}>
              Cancel
            </button>
          </>
        }
      />


      <ReusableModal
        show={exitModel}
        onClose={() => setExitModel(false)}
        title={<span>{calltypedata?.tradesymbol}</span>}
        body={
          <form className="row g-3">
            <div className="col-md-12">
              <label htmlFor="inputName" className="form-label">
                Price
              </label>
              <input
                type="number"
                className="form-control"
                id="inputName"
                placeholder="Price"
                value={exitorderdata?.price}
                onChange={(e) => {
                  setExitOrderdata({ ...exitorderdata, price: e.target.value });
                }}
              />
            </div>
            <div className="col-md-12">
              <label htmlFor="inputName" className="form-label">
                Entry Type
              </label>
              <input
                disabled
                type="string"
                className="form-control"
                id="inputName"
                placeholder=""
                value={exitorderdata?.calltype}
                onChange={(e) => {
                  setExitOrderdata({ ...exitorderdata, calltype: e.target.value });
                }}
              />
            </div>
            <div className="col-md-12">
              <label htmlFor="inputQuantity" className="form-label">
                Quantity
              </label>
              <input
                type="number"
                className="form-control"
                id="inputQuantity"
                placeholder="Quantity"
                value={exitorderdata?.quantity}
                onChange={(e) => {
                  setExitOrderdata({ ...exitorderdata, quantity: e.target.value });
                }}
              />
            </div>
          </form>
        }
        footer={
          <>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                ExitPlaceOrder();
              }}
            >
              Exit
            </button>
            <button className="btn btn-light" onClick={() => setExitModel(false)} >
              Cancel
            </button>
          </>
        }
      />

      <ReusableModal
        show={viewModel}
        onClose={() => setViewModel(false)}
        title={<span>Detail</span>}
        body={<div dangerouslySetInnerHTML={{ __html: description }} />}
      />


      <ReusableModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title="Description"
        body={<p>{avoidDescription || "No description available."}</p>}
      />
    </Content>
  );
}

export default Trade;

